import React from 'react';
import { Grid, Heading } from '@arrow-ds/react';
import InputField from 'src/common/InputField/InputField';
import './FTAModeller.scss';
import FTAResults from '../FTAResults/FTAResults';
import { FtaInputs, ProductNames } from '../fta.interface';

interface FTAModellerProps {
  calculatorData: any[];
}

const FTAModeller: React.FC<FTAModellerProps> = ({ calculatorData = [] }) => {
  const [ftaDetails, setFtaDetails] = React.useState<FtaInputs>({
    investmentAmount: 0,
    investmentTerm: 0,
    product: '',
  });

  const handleAmountChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFtaDetails({
      ...ftaDetails,
      investmentAmount: e.target.value,
    });
  };

  const handleTermChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFtaDetails({
      ...ftaDetails,
      investmentTerm: e.target.value,
    });
  };

  const handleProductChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFtaDetails({
      ...ftaDetails,
      product: e.target.value,
    });
  };
  const fieldsData = (field: string) => {
    const fieldData = calculatorData.map((item: any) => {
      if (field === 'Term') {
        return `${item[field].replace(/\D/g, '')} years`;
      } else if (field === 'Product Option') {
        return ProductNames[item[field]];
      }
      return `£${Number(item[field].replace(/\D/g, '')).toLocaleString()}`;
    });
    return fieldData.filter((item: any, index: number) => fieldData.indexOf(item) === index);
  };

  return (
    <Grid row>
      <Grid
        col={{
          lg: 7, md: 7, sm: 6, xl: 7, xs: 12,
        }}
        className="ftaModellerInputs"
      >
        <Heading level={3} className="subHeading">Investment Information</Heading>
        <InputField label="Investment amount" options={fieldsData('Investment')} onChange={handleAmountChange} type="dropdown" />
        <InputField label="Term" options={fieldsData('Term')} onChange={handleTermChange} type="dropdown" />
        <InputField label="Product" options={fieldsData('Product Option')} onChange={handleProductChange} type="radio" />
      </Grid>
      <Grid
        col={{
          lg: 5, md: 5, sm: 6, xl: 5, xs: 12,
        }}
      >
        <FTAResults ftaInputs={ftaDetails} calculatorData={calculatorData} />
      </Grid>
    </Grid>
  );
};

export default FTAModeller;
